import { render, staticRenderFns } from "./ShopTabsComponent.vue?vue&type=template&id=e5b3275a&scoped=true&"
import script from "./ShopTabsComponent.vue?vue&type=script&lang=ts&"
export * from "./ShopTabsComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ShopTabsComponent.vue?vue&type=style&index=0&id=e5b3275a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b3275a",
  null
  
)

export default component.exports